module.exports = __webpack_public_path__ + "img/imposta-logo-jobmule.57ecaa6f.png";